<template>

	<div class="login_wbox">
		<div class="inter">
			<div class="div1">
				<div class="login_form" v-if="!wangji">
					<div class="user_login_menu">
						<div class="item" :class="{'active':active == 0}" @click="active = 0">
							登录
						</div>
					</div>
					<div class="form_content" v-if="active == 0">
						<div class="item">

							<div class="input">
								<el-input v-model="acc" placeholder="请输入账号"></el-input>
							</div>
						</div>
						<div class="item">

							<div class="input">
								<el-input v-model="pass" show-password placeholder="请输入密码"></el-input>
							</div>
						</div>
					</div>

					<div class="login_btn_text" v-if="active == 0">
						<div class="sp1" @click="wangji = true">忘记密码?</div>
					</div>

					<div class="debtn" @click="login" v-if="active == 0">登录</div>
				</div>


				<div class="login_form" v-if="wangji">
					<div class="user_login_menu" style="justify-content: space-between;">
						<div class="item active">
							忘记密码
						</div>
						<div class="item" style="font-size: 18px;color: #487cf7; font-weight: 400;margin-right: 0;"
							@click="denglu">
							去登录
						</div>
					</div>

					<div class="form_content">
						<div class="item">

							<div class="input">
								<el-input v-model="acc" placeholder="请输入手机号"></el-input>
							</div>
						</div>
						<div class="item">

							<div class="input">
								<el-input v-model="code" show-password placeholder="请输入验证码"></el-input>
							</div>
							<div class="code" style="margin-left: 10px;width: 100px;" @click="startCountdown2">
								<div class="debtn" style="font-size: 14px;">
									{{ isCountingDown ? countdown + 's' : '获取验证码' }}
								</div>
							</div>
						</div>
						<div class="item">

							<div class="input">
								<el-input v-model="pass" show-password placeholder="请输入密码"></el-input>
							</div>
						</div>
						<div class="item">

							<div class="input">
								<el-input v-model="pass2" show-password placeholder="请确认密码"></el-input>
							</div>
						</div>
					</div>

					<div class="debtn" @click="respass">修改并登录</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
	import {
		Notification,
		Message
	} from 'element-ui'
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 0,
				title: "",
				info: {},
				acc: "",
				pass: "",
				pass2: "",
				code: "",
				countdown: 60, // 初始倒计时时间（秒）
				timer: null,
				isCountingDown: false,
				wangji: false

			}
		},
		created: function(data) {

			// this.getDetail();


		},
		watch: {
			$route() {

			}
		},
		methods: {
			denglu() {
				this.active = 0
				this.wangji = false
			},
			startCountdown() {
				if (this.isCountingDown) return;
				var that = this;
				// 开始倒计时
				this.isCountingDown = true;

				this.rq.requests.post("api/game/hall/send", {
					mobile: that.acc,
					event: 'register',
				}).then(res => {
					Message.success({
						message: "发送成功",
						duration: 3000
					})
					that.timer = setInterval(() => {
						if (that.countdown > 0) {
							that.countdown--;
						} else {
							clearInterval(that.timer);
							that.timer = null;
							that.countdown = 60; // 重置倒计时时间
							that.isCountingDown = false;
						}
					}, 1000);

				}).catch(error => {
					Message.closeAll();
					Message.error({
						message: error.msg,
						duration: 3000
					})
					that.isCountingDown = false;
				})
			},


			startCountdown2() {
				if (this.isCountingDown) return;
				var that = this;
				// 开始倒计时
				this.isCountingDown = true;

				this.rq.requests.post("api/game/hall/send", {
					mobile: that.acc,
					event: 'resetpwd',
				}).then(res => {
					Message.success({
						message: "发送成功",
						duration: 3000
					})
					that.timer = setInterval(() => {
						if (that.countdown > 0) {
							that.countdown--;
						} else {
							clearInterval(that.timer);
							that.timer = null;
							that.countdown = 60; // 重置倒计时时间
							that.isCountingDown = false;
						}
					}, 1000);

				}).catch(error => {
					Message.closeAll();
					Message.error({
						message: error.msg,
						duration: 3000
					})
					that.isCountingDown = false;
				})
			},


			respass() {
				var that = this;
				this.rq.requests.post("api/game/user/resetpwd", {
					mobile: that.acc,
					password: that.pass,
					captcha: that.code,
				}).then(res => {


					localStorage.setItem('usertoken', res.data.userinfo.token)
					that.$store.commit('SET_userinfo', res.data.userinfo)
					that.$router.push('/user')


				}).catch(error => {
					Message.closeAll();
					Message.error({
						message: error.msg,
						duration: 3000
					})
				})
			},

			login() {
				var that = this;
				if (this.active == 0) {
					this.rq.requests.post("api/game/user/login", {
						account: that.acc,
						password: that.pass,
					}).then(res => {

						localStorage.setItem('usertoken', res.data.userinfo.token)
						that.$store.commit('SET_userinfo', res.data.userinfo)
						that.$store.commit('SET_login', true)
						that.$router.push('/user')


					}).catch(error => {

						Message.closeAll();
						Message.error({
							message: error.msg,
							duration: 3000
						})
					})
				}
				if (this.active == 1) {
					this.rq.requests.post("api/game/user/register", {
						username: that.acc,
						mobile: that.acc,
						email: that.acc + '@qq.com',
						password: that.pass,
						code: that.code,
					}).then(res => {


						localStorage.setItem('usertoken', res.data.userinfo.token)
						that.$store.commit('SET_userinfo', res.data.userinfo)
						that.$router.push('/user')


					}).catch(error => {
						Message.closeAll();
						Message.error({
							message: error.msg,
							duration: 3000
						})
					})
				}



			},

		}


	}
</script>